import { render, staticRenderFns } from "./AdminPermissionGroupView.vue?vue&type=template&id=6ce23353&scoped=true"
import script from "./AdminPermissionGroupView.vue?vue&type=script&lang=js"
export * from "./AdminPermissionGroupView.vue?vue&type=script&lang=js"
import style0 from "./AdminPermissionGroupView.vue?vue&type=style&index=0&id=6ce23353&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce23353",
  null
  
)

export default component.exports